<template>
  <transition name="toast-fade">
    <div class="toast-container" v-if="visible">
      <div class="toast-box" :class="type">
        <div class="toast-icon">
          <span v-if="type === 'success'">✓</span>
          <span v-else-if="type === 'error'">✕</span>
          <span v-else-if="type === 'warning'">!</span>
          <span v-else>i</span>
        </div>
        <div class="toast-message">{{ message }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
import { eventBus } from '../plugins/dialog'

export default {
  name: 'Toast',
  data() {
    return {
      visible: false,
      message: '',
      type: 'info',
      timer: null
    }
  },
  created() {
    eventBus.$on('toast:show', ({ message, type, duration }) => {
      this.show(message, type, duration)
    })
  },
  methods: {
    show(message, type = 'info', duration = 2500) {
      this.message = message
      this.type = type
      this.visible = true
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.visible = false
      }, duration)
    },
    success(message, duration) { this.show(message, 'success', duration) },
    error(message, duration) { this.show(message, 'error', duration) },
    warning(message, duration) { this.show(message, 'warning', duration) },
    info(message, duration) { this.show(message, 'info', duration) }
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  pointer-events: none;
}

.toast-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
  min-width: 280px;
  max-width: 480px;
  pointer-events: auto;
}

.toast-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
  color: #fff;
}

.toast-box.success .toast-icon { background: #22c55e; }
.toast-box.error .toast-icon { background: #ef4444; }
.toast-box.warning .toast-icon { background: #f59e0b; }
.toast-box.info .toast-icon { background: #2563eb; }

.toast-message {
  font-size: 14px;
  color: #1a1a2e;
  font-weight: 500;
  line-height: 1.4;
}

.toast-fade-enter-active {
  transition: all 0.3s ease;
}

.toast-fade-leave-active {
  transition: all 0.3s ease;
}

.toast-fade-enter {
  opacity: 0;
  transform: translateY(-20px);
}

.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
